import FaqArticlesList from "../FaqArticlesList";

function FaqCategory({ faqCategory }) {
  return (
    <div>
      <h2 className="h3 mb-3 faq-jump-link" id={faqCategory.slug}>
        {faqCategory.name}
      </h2>

      <FaqArticlesList
        faqArticles={faqCategory.articles}
        firstArticleOpen
      />
    </div>
  );
}

export default FaqCategory;